__turbopack_context__.v({
  "root": "styles-module-scss-module__aOrzaG__root",
  "stash": "styles-module-scss-module__aOrzaG__stash",
  "timer": "styles-module-scss-module__aOrzaG__timer",
});
